(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-attachments"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
   $('.attachments-slider-inner').slick({
     dots: false,
     infinite: false,
     arrows: true,
     loop:false,
     speed: 400,
     slidesToShow: 6,
     centerMode: false,
     variableWidth: false,
     slidesToScroll: 1,
     prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//cdn.shopify.com/s/files/1/0433/3282/9343/files/slider-arrow.png' alt='slider arrows'></button>",
     nextArrow:"<button type='button' class='slick-next pull-right'><img src='//cdn.shopify.com/s/files/1/0433/3282/9343/files/slider-arrow.png' alt='slider arrows'></button>",
      responsive: [
        {
          breakpoint: 1550,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
   });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-loop-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.product-loop-slider-inner').slick({
       dots: false,
       infinite: false,
       arrows: true,
       loop:false,
       speed: 400,
       slidesToShow: 5,
       centerMode: false,
       variableWidth: false,
       slidesToScroll: 1,
       prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//cdn.shopify.com/s/files/1/0560/8770/7708/files/right-arrows.png' alt='slider arrows'></button>",
       nextArrow:"<button type='button' class='slick-next pull-right'><img src='//cdn.shopify.com/s/files/1/0560/8770/7708/files/right-arrows.png' alt='slider arrows'></button>",
        responsive: [
          {
            breakpoint: 1550,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
     });
});

  } catch(e) { console.error(e); }
})();
})();
